module.exports = __webpack_public_path__ + "img/home_top_wenben.90df1684.png";